import React from 'react';
import { Helmet } from 'react-helmet-async';

import { InsightResolutionsContextProvider } from './InsightResolutionsContext';
import { InsightResolutionsDataGrid } from './InsightResolutionsDataGrid';

export const PAGE_TITLE = 'Insight Resolutions';

export const InsightResolutionsContainer = () => {
  return (
    <>
      <Helmet>
        <title>{PAGE_TITLE}</title>
      </Helmet>
      <InsightResolutionsContextProvider>
        <InsightResolutionsDataGrid />
      </InsightResolutionsContextProvider>
    </>
  );
};
